import Loader from "Components/Loader";
import React, { useEffect, useState } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import utils from "utils";
import api from "utils/api";
import AddNewUser from "./AddNewUser";
// import "./Billing.scss";
function EditUser(props) {
  const [loader, setLoading] = useState(true);
  const [editData, setEditData] = useState({});
  const [formActionState, formAction] = useState(false);
  const location = useLocation();
  const history = useHistory();

  const user_id = location.state?.user_id;

  function fetchClinicianDetails() {
    // const doctor_id = location.state?.doctor_id;
    // if (!doctor_id) {
    //   history.push(`${props.user_details.baseUrl}/clinician`);
    // } else {
    // const query = new URLSearchParams({
    //   doctor_id: doctor_id,
    // }).toString();
    api
      .get_edit_user_details({ user_id })
      .then((response) => {
        if (response.data.status === 200) {
          const result = response.data.data;
          setEditData(result);
        } else {
          message.error(response.data.status);
        }
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
    // }
  }
  useEffect(() => {
    fetchClinicianDetails();
  }, []);
  const unsavedPopup = () => {
    utils.Modal(true, {
      width: "650px",
      // closable: false,
      content: (
        <div className="finish-Consult-Modal">
          <div className="finish-header">Switch Tab</div>
          <div className="finish-wrapper">
            <div className="finish-title">
              There are unsaved changes. Are you sure to switch Tab?
            </div>
            <div className="finish-btns">
              <button
                className="action-yes"
                onClick={() => {
                   utils.Modal(false);
                   history.push(`${props.user_details.baseUrl}/user-management`);
                }}
              >
                Yes
              </button>
              <button
                className="action-no"
                onClick={() => {
                  utils.Modal(false);
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      ),
    });
  };
  return (
    <div className="billing">
      {loader ? (
        <Loader />
      ) : (
        <>
          <div
            onClick={() => {
              if (formActionState) {
                unsavedPopup();
              } else {
                history.push(`${props.user_details.baseUrl}/user-management`);
              }
            }}
            className="previous-page-button"
          >{`< Back To Previous Page`}</div>
          {editData && (
            <AddNewUser
              formAction={formAction}
              editData={{ user_id, ...editData }}
              submitButtonAction={() => {
                history.push(`${props.user_details.baseUrl}/user-management`);
              }}
              formActionState={formActionState}
            />
          )}
        </>
      )}
    </div>
  );
}
const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer?.user_details,
  };
};
const mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps)(EditUser);